import { createSelector } from 'reselect'

import { IApplicationState } from '@store/index'
import { SupportedGenericReducerPCRChannels } from '../types'

const selectPCRMetrics = (
  state: IApplicationState,
  channel: SupportedGenericReducerPCRChannels,
) => {
  return state.reportings[channel]
}

export const selectPcrMetricsSummary = createSelector(
  selectPCRMetrics,
  (state: IApplicationState, channel: SupportedGenericReducerPCRChannels, campaignId) => campaignId,
  (_, channel: SupportedGenericReducerPCRChannels) => channel,
  (pcrMetrics, campaignId) => {
    return pcrMetrics.metricsSummaryByCampaignId[campaignId] ?? {}
  },
)

export const selectPcrMetricIds = createSelector(
  selectPCRMetrics,
  (state: IApplicationState, channel: SupportedGenericReducerPCRChannels, campaignId) => campaignId,
  (_, channel: SupportedGenericReducerPCRChannels) => channel,
  (pcrMetrics, campaignId) => {
    return pcrMetrics.metricIdsByCampaignId[campaignId] ?? []
  },
)

export const selectPcrMetrics = createSelector(
  selectPCRMetrics,
  (state: IApplicationState, channel: SupportedGenericReducerPCRChannels, id) => id,
  (_, channel: SupportedGenericReducerPCRChannels) => channel,
  (pcrMetrics, id) => {
    return pcrMetrics.metricsById[id] ?? {}
  },
)
